import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import FlightDown from '@assets/FlightDown.svg';
import FlightUp from '@assets/FlightUp.svg';
import Hotel from '@assets/Hotel.svg';
import Image from '@components/Image/Image';
import { TimeFormat } from '@enums/timeFormat.enum';
import { LocationType, StopType } from '@enums/trips.enum';
import type { ILocation, Passenger, TripStop } from '@store/trips/tripsSlice';

import classes from './TripPoint.module.scss';

type Props = {
	date: TripStop['date'];
	stopType: Passenger['stopType'];
	locationName: ILocation['displayName'];
	locationType: ILocation['type'];
};

export const TripPoint: React.FC<Props> = ({ stopType, locationName, locationType, date }: React.PropsWithChildren<Props>) => {
	const { t } = useTranslation();
	return (
		<div className={classes['container']}>
			<Image
				src={locationType === LocationType.Airport ? (stopType === StopType.Pick ? FlightDown : FlightUp) : Hotel}
				name={t('tripCard.imgAlt')}
				size={32}
			/>
			<div className={classes['textContainer']}>
				<div className={classes['stopTypeContainer']}>
					<p className={classes['stopType']}>{t(`tripPoint.${stopType}`)}</p>
					<p className={classes['date']}>{dayjs.unix(date).format(TimeFormat.Time24Hour)}</p>
				</div>
				<p className={classes['locationName']}>{locationName}</p>
			</div>
		</div>
	);
};
